import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import moment from 'moment';
import { styled } from '@mui/material/styles';
import { Box, Typography, Tooltip, IconButton, SvgIcon } from '@mui/material';
import { useSnackbar } from 'notistack';
import { ExternalLink, Download, Copy } from 'react-feather';
import { clipboardCopy } from '../../../../utils/clipboardCopy.js';

const PREFIX = 'DebugFile';
const classes = {
    greyBox: `${PREFIX}-greyBox`,
};
const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.greyBox}`]: {
        // @ts-ignore
        backgroundColor: theme.palette.background.dark,
        padding: '5px 10px;',
        wordBreak: 'break-all',
    },
}));
const DebugFile = ({ title, dateTime, filePath, logService, logAxios, type, }) => {
    const ref = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const handleCopy = () => {
        clipboardCopy(filePath);
        enqueueSnackbar('Copiado para área de transferência', {
            variant: 'info',
        });
    };
    const baseUrl = () => {
        return logAxios.defaults.baseURL;
    };
    const token = () => {
        const splitToken = logAxios.defaults.headers.common.Authorization.split(' ');
        return splitToken[1];
    };
    const handleInline = () => {
        window.open(`${baseUrl()}${logService.download(type, 'inline')}&token=${token()}`, '_blank');
    };
    const handleAttachment = () => {
        window.open(`${baseUrl()}${logService.download(type, 'attachment')}&token=${token()}`);
    };
    const formatDateTime = () => {
        return moment(dateTime).format('DD/MM/YYYY HH:mm');
    };
    const fileName = () => {
        return filePath.replace(/^.*[\\/]/, '');
    };
    return (jsxs(StyledBox, Object.assign({ mb: 3 }, { children: [jsxs(Box, Object.assign({ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }, { children: [jsx(Typography, Object.assign({ variant: "h6" }, { children: title })), jsxs(Box, Object.assign({ display: "flex", flexDirection: "row", alignItems: "center" }, { children: [jsx(Tooltip, Object.assign({ title: "Abrir em uma nova aba" }, { children: jsx(IconButton, Object.assign({ color: "inherit", ref: ref, onClick: handleInline }, { children: jsx(SvgIcon, Object.assign({ fontSize: "small" }, { children: jsx(ExternalLink, {}) })) })) })), jsx(Tooltip, Object.assign({ title: "Download do arquivo" }, { children: jsx(IconButton, Object.assign({ color: "inherit", ref: ref, onClick: handleAttachment }, { children: jsx(SvgIcon, Object.assign({ fontSize: "small" }, { children: jsx(Download, {}) })) })) })), jsx(Tooltip, Object.assign({ title: "Copiar caminho" }, { children: jsx(IconButton, Object.assign({ color: "inherit", ref: ref, onClick: handleCopy }, { children: jsx(SvgIcon, Object.assign({ fontSize: "small" }, { children: jsx(Copy, {}) })) })) })), jsx(Typography, Object.assign({ variant: "body2" }, { children: formatDateTime() }))] }))] })), jsx(Box, Object.assign({ mt: 1 }, { children: jsx(Typography, Object.assign({ variant: "subtitle1", className: classes.greyBox }, { children: fileName() })) }))] })));
};

export { DebugFile };
